import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function HomeRedirect() {
  const { role, loading } = useAuth();

  if (loading) return null;

  if (role === 'client') return <Navigate to="/client/rooster" replace />;
  return <Navigate to="/coach/rooster" replace />;
}
